// extracted by mini-css-extract-plugin
module.exports = {"metrics-container":"MetricsWidget_metrics-container__Ej8y5","metric":"MetricsWidget_metric__1WPPu","with-tooltip":"MetricsWidget_with-tooltip__1md9s"};